<template>
  <div class="auth-page">
    <div class="auth-bg-pattern"></div>
    <div class="auth-container fade-in">
      <div class="auth-header">
        <img class="logotipo" src="/logo-white.png" alt="logo">
      </div>
      
      <div class="auth-card">
        <form @submit.prevent="recoverPassword" v-if="!showSuccess">
          <div class="auth-title">
            <h2>Recuperar senha</h2>
            <p>Insira o email associado à sua conta</p>
          </div>
          
          <div class="field">
            <label class="label">Email</label>
            <div class="control has-icons-left">
              <input 
                required 
                class="input" 
                type="email" 
                placeholder="ex. cliente@exemplo.com" 
                v-model="email"
              >
              <span class="icon is-small is-left">
                <i class="fas fa-envelope"></i>
              </span>
            </div>
          </div>

          <button 
            class="button is-link is-fullwidth" 
            :class="{'is-loading': isLoading}"
          >
            Enviar instruções
          </button>
        </form>
        
        <div v-else class="success-state">
          <div class="success-icon">
            <i class="fas fa-envelope"></i>
          </div>
          <h2>Email enviado!</h2>
          <p>Verifique a sua caixa de correio para instruções sobre como recuperar a sua senha.</p>
        </div>
        
        <div class="auth-footer">
          <router-link to="/login">
            <i class="fas fa-arrow-left mr-2"></i>
            Voltar ao login
          </router-link>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "RecoverPassword",
  data() {
    return {
      email: "",
      showSuccess: false,
      isLoading: false
    }
  },
  methods: {
    recoverPassword() {
      this.isLoading = true;
      fetch(`/api/users/sendrecoverpasswordemail`, {
        method: "post",
        body: JSON.stringify({
          email: this.email
        })
      }).then(res => {
        this.showSuccess = (res.status === 200);
        this.isLoading = false;
      });
    }
  }
}
</script>

<style scoped>
.auth-page {
  width: 100vw;
  height: 100vh;
  background: linear-gradient(135deg, #0755A0 0%, #0F172A 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  overflow: hidden;
}

.auth-bg-pattern {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: 
    radial-gradient(circle at 25% 25%, rgba(255,255,255,0.1) 1px, transparent 1px),
    radial-gradient(circle at 75% 75%, rgba(255,255,255,0.05) 1px, transparent 1px);
  background-size: 50px 50px;
  pointer-events: none;
}

.auth-container {
  width: 100%;
  max-width: 420px;
  padding: 20px;
  position: relative;
  z-index: 1;
}

.auth-header {
  text-align: center;
  margin-bottom: 2rem;
}

.auth-header .logotipo {
  width: 180px;
}

.auth-card {
  background: var(--surface);
  border-radius: var(--radius-xl);
  padding: 2.5rem;
  box-shadow: var(--shadow-xl);
}

.auth-title {
  margin-bottom: 2rem;
}

.auth-title h2 {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 0.5rem;
}

.auth-title p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.field {
  margin-bottom: 1.5rem;
}

.auth-card .input {
  height: 48px;
  font-size: 1rem;
  padding-left: 2.5rem;
}

.auth-card .input:focus {
  border-color: var(--primary);
  box-shadow: 0 0 0 3px rgba(7, 85, 160, 0.15);
}

.auth-card .icon {
  height: 48px;
  line-height: 48px;
}

.auth-card .button {
  height: 48px;
  font-size: 1rem;
  font-weight: 600;
  background: linear-gradient(135deg, var(--primary) 0%, var(--primary-dark) 100%);
  border: none;
}

.auth-card .button:hover {
  background: linear-gradient(135deg, var(--primary-dark) 0%, #042C57 100%);
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(7, 85, 160, 0.3);
}

.success-state {
  text-align: center;
  padding: 1rem 0;
}

.success-icon {
  width: 64px;
  height: 64px;
  margin: 0 auto 20px;
  background: var(--primary-50);
  border-radius: var(--radius-lg);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  color: var(--primary);
}

.success-state h2 {
  font-size: 1.25rem;
  font-weight: 700;
  color: var(--text-primary);
  margin-bottom: 8px;
}

.success-state p {
  color: var(--text-secondary);
  font-size: 0.9rem;
}

.auth-footer {
  text-align: center;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #E2E8F0;
}

.auth-footer a {
  color: var(--text-secondary);
  font-size: 0.9rem;
  text-decoration: none;
  display: inline-flex;
  align-items: center;
}

.auth-footer a:hover {
  color: var(--primary);
}
</style>
